import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#92b21f' },
    secondary: { main: '#ff4081' },
  },
});

export default theme;
